import React, { useState } from 'react';
import { FiEye, FiEyeOff, FiShield } from 'react-icons/fi';
import api from '../../config/api';

/**
 * Masked sensitive value with optional reveal (audited server-side).
 *
 * The reveal affordance states plainly that access is logged, and a revealed
 * value is visually flagged so it is obvious it re-masks itself shortly.
 */
const SensitiveField = ({ entityType, entityId, field, masked, canReveal = false }) => {
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const revealed = value != null;
  const display = revealed ? value : masked || '—';

  const onReveal = async () => {
    if (!canReveal || !entityId) return;
    setLoading(true);
    setError('');
    try {
      const { data } = await api.post('/accounting/reveal', { entityType, entityId, field });
      setValue(data.value || '');
      setTimeout(() => setValue(null), 30000);
    } catch (err) {
      setError(err?.response?.data?.error || 'Reveal failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <span className="erp-sensitive-field">
      <code className={`erp-sensitive-value${revealed ? ' is-revealed' : ''}`}>{display}</code>
      {canReveal && !revealed && (
        <button
          type="button"
          className="erp-sensitive-btn"
          onClick={onReveal}
          disabled={loading}
          title="Reveal the full value — this access is recorded in the audit log"
        >
          <FiEye aria-hidden />
          {loading ? 'Revealing…' : 'Reveal'}
        </button>
      )}
      {canReveal && !revealed && !error && (
        <span className="erp-sensitive-note">
          <FiShield aria-hidden /> Access is audited
        </span>
      )}
      {revealed && (
        <>
          <button
            type="button"
            className="erp-sensitive-btn"
            onClick={() => setValue(null)}
            title="Hide the value again"
          >
            <FiEyeOff aria-hidden /> Hide
          </button>
          <span className="erp-sensitive-note">
            <FiShield aria-hidden /> Logged · hides in 30s
          </span>
        </>
      )}
      {error && <span className="erp-sensitive-error" role="alert">{error}</span>}
    </span>
  );
};

export default SensitiveField;
